import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b11d59e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ptoContainer-fluid",
  id: "divPtoContainer-fluid"
}
const _hoisted_2 = { class: "card ptoCard" }
const _hoisted_3 = {
  id: "ptobalance-content-loading",
  class: "text-center mt-3"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "divPTOBalanceHeader" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "ptoHeader" }, "PTO Balance"),
  /*#__PURE__*/_createElementVNode("hr", { class: "hrline" })
], -1))
const _hoisted_5 = { class: "fa-2x" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading PTO Balance...")
], -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { id: "divPTOBalanceLabels" }
const _hoisted_9 = {
  class: "paddingCtrls",
  id: "lblPtoBalance",
  style: {"padding-left":"10px"}
}
const _hoisted_10 = {
  id: "ptoBalanceData",
  class: "text-muted paddingCtrls"
}
const _hoisted_11 = {
  class: "paddingCtrls",
  id: "lblPayPeriodAccural",
  style: {"padding-left":"10px"}
}
const _hoisted_12 = {
  id: "payPeriodAccural",
  class: "text-muted paddingCtrls"
}
const _hoisted_13 = { id: "divPTOBalanceGrid" }
const _hoisted_14 = {
  id: "ptobalance-content",
  class: "mt-3"
}
const _hoisted_15 = {
  id: "ptoGrid",
  class: "scrollBar"
}
const _hoisted_16 = { class: "ptoTable" }
const _hoisted_17 = { class: "th_HeaderRow" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "divPTOBalanceFooter" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "text-muted",
    style: {"padding-left":"10px"}
  }, " PTO balances are shown as estimates only.")
], -1))
const _hoisted_19 = {
  key: 1,
  id: "ptobalance-message",
  class: "text-center mt-3"
}
const _hoisted_20 = { id: "ptobalance-message-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_label = _resolveComponent("neu-label")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_font_awesome_icon, {
            spin: true,
            icon: ['fas', 'circle-notch'],
            size: "lg"
          })
        ]),
        _hoisted_6
      ], 512), [
        [_vShow, _ctx.isShowLoader]
      ]),
      (_ctx.isShowPTOContent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_9, [
                  _createTextVNode(" PTO Balance: "),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.ptoBalance), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_11, [
                  _createTextVNode(" Pay Period Accrual: "),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.payPeriodAccural), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("table", _hoisted_16, [
                    _createElementVNode("tr", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PTOBalanceColumns, (col, index) => {
                        return (_openBlock(), _createElementBlock("th", {
                          key: col,
                          class: _normalizeClass([index == 0? 'colTextWidth fixedCol': 'colDateWidth'])
                        }, [
                          _createVNode(_component_neu_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(col), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 2))
                      }), 128))
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PTOBalanceData, (pto, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: _normalizeClass(["neu-table__row--small", [index == 2 ? 'bold': '', index == 1 ? 'highlight' : '']]),
                        key: _ctx.PTOBalanceData.indexOf(pto)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(pto), (dataItem, index) => {
                          return (_openBlock(), _createElementBlock("td", {
                            key: dataItem,
                            class: _normalizeClass([index == 0? 'fixedCol fontNormal': '', 
                                                (_ctx.highlightedColumn!= null && _ctx.highlightedColumn.length > 0 && _ctx.highlightedColumn.includes(dataItem)) ? 'highlight' : ''])
                          }, [
                            _createVNode(_component_neu_label, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(pto[dataItem]), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ], 2))
                        }), 128))
                      ], 2))
                    }), 128))
                  ])
                ])
              ])
            ]),
            _hoisted_18
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShowPTOMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.ptoMessage), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}